// This component uses the carousel from workouts but allows us to feed it our own data //

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';

import CarouselCard from '../../../workouts/components/presentational/CarouselCard';
import Carousel from '../../../workouts/components/presentational/Carousel';
import { setIsPreviewCarouselShowing } from '../../ducks/navigatorActions';

// Disable interactions as this is only meant to be a preview
const CardWrapper = styled.div`
  pointer-events: none;
  width: 100%;
  height: 100%;
`;

const PreviewCarousel = () => {
  const dispatch = useDispatch();

  const workoutItems = useSelector(
    (state) => state.navigator.data.currentWorkout.workoutItems || [],
  );
  const isWorkoutsCarouselShowing = useSelector(
    (state) => state.navigator.ui.isPreviewCarouselShowing,
  );

  const setPreviewCarouselShowing = (bool) => {
    dispatch(setIsPreviewCarouselShowing(bool));
  };

  const workoutCardsMapper = (
    inputArray,
  ) => inputArray.map((workoutObject, index) => ({
    cardElement: (
      <CardWrapper>
        <CarouselCard
          workoutObject={workoutObject.item}
          outerIndex={workoutObject.index}
          sessionIndex={workoutObject.sessionIndex}
          index={index}
        />
      </CardWrapper>
    ),
    shouldExpand: workoutObject.item.tableHeaders && workoutObject.item.tableHeaders.length >= 3,
    key: workoutObject.item.id,
  }));

  const flattenArray = (unflattenedArray) => {
    const flattenedArray = [];
    unflattenedArray.forEach((item, index1) => {
      flattenedArray.push({ item, index: index1 });
      if (item.type === 'BR') {
        item.sessionBreakItems.forEach((sessionBreakItem, innerIndex) => {
          flattenedArray.push({ item: sessionBreakItem, index: index1, sessionIndex: innerIndex });
        });
      }
    });
    return flattenedArray;
  };

  return (
    <Carousel
      cards={workoutCardsMapper(flattenArray(workoutItems))}
      isShowing={isWorkoutsCarouselShowing}
      setIsShowing={setPreviewCarouselShowing}
      hideExtraButtons
    />
  );
};

export default PreviewCarousel;
